// extracted by mini-css-extract-plugin
export default {"alertWrapper":"Auth_alertWrapper__Z2XQz","text":"Auth_text__2zgRV","btn":"Auth_btn__QEgIb"};